module.exports = __webpack_public_path__ + "img/uk.937078e4.svg";